<template>
  <div class="route-view dark">
    <div class="text-right">
      <b-dropdown style="cursor:pointer" :triggers="['hover']" aria-role="list">
        <template #trigger>
          <div :class="langIcon" />
        </template>
        <b-dropdown-item
          aria-role="listitem"
          :disabled="langIcon === 'svg-icon-th'"
          @click="changeLocale('th')"
        >
          <div class="svg-icon-th" />
          <span class="has-text-black m-l-5"> ไทย</span>
        </b-dropdown-item>
        <b-dropdown-item
          aria-role="listitem"
          :disabled="langIcon === 'svg-icon-la'"
          @click="changeLocale('la')"
        >
          <div class="svg-icon-la" />
          <span class="has-text-black m-l-5"> ລາວ</span>
        </b-dropdown-item>
        <b-dropdown-item
          aria-role="listitem"
          :disabled="langIcon === 'svg-icon-en'"
          @click="changeLocale('en')"
        >
          <div class="svg-icon-en" />
          <span class="has-text-black m-l-5"> Eng</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="logo">
      <img src="/images/logo.png" />
    </div>
    <div class="section-title ">{{ $t('login.loginTitle') }}</div>
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="field">
          <label for="" class="label">{{ $t('login.phoneLabel') }}</label>
          <div class="control has-icons-left">
            <input
              v-model="username"
              type="text"
              :placeholder="$t('login.phoneLabel')"
              class="input text-center"
              required
              @input="handlerInput"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <label for="" class="label">{{ $t('login.passwordLabel') }}</label>
          <div class="control has-icons-left">
            <input
              v-model="password"
              type="password"
              placeholder="*******"
              class="input text-center"
              required
              @input="handlerInput"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-lock"></i>
            </span>
          </div>
        </div>
        <div class="error has-text-centered m-t-30">
          {{ error }}
        </div>
        <div>
          <button type="submit" class="button full-100 is-primary">
            <i class="fas fa-sign-in-alt"></i>{{ $t('login.loginBtn') }}
          </button>
          <div class="flex-center m-t-15">
            <div>
              <i class="fas fa-user m-r-5"></i>
              <a href="/register">{{ $t('login.registerLink') }}</a>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- <div class="field">
              <label for="" class="checkbox">
                <input v-model="isRemember" type="checkbox" />
                Remember me
              </label>
            </div> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import BottomMenu from '@/components/BottomMenu'
import { getLocale, setCookieI18n, setLocale } from '@/utils/locale'
export default {
  name: 'Login',
  props: {
    page: String
  },
  data() {
    return {
      username: null,
      password: null,
      isRemember: false,
      error: null,
      langIcon: null
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {
    this.setLangIcon()
  },
  methods: {
    ...mapActions('auth', ['login']),

    handleRegister() {
      this.$router.push('/register')
    },
    handleSubmit() {
      if (!this.username) return false
      if (!this.password) return false

      this.login({
        username: this.username,
        password: this.password,
        isRemember: this.isRemember
      })
        .then(() => {})
        .catch(error => {
          this.error = error
        })
      // e.preventDefault()
    },

    handlerInput() {
      if (this.error) {
        this.error = null
      }
    },
    setLangIcon() {
      const lang = getLocale()
      if (lang === 'th') {
        this.langIcon = 'svg-icon-th'
      } else if (lang === 'la') {
        this.langIcon = 'svg-icon-la'
      } else if (lang === 'en') {
        this.langIcon = 'svg-icon-en'
      }
    },
    changeLocale(lang) {
      setLocale(lang)
      setCookieI18n(lang.toUpperCase())
      this.setLangIcon()
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .dropdown-content {
  width: 40%;
}
@media (max-width: 550px) {
  ::v-deep .dropdown-content {
    width: 100%;
  }
}

::v-deep .dropdown-trigger {
  padding: 1px 4px;
  border: 1px solid #eae9e9;
  border-radius: 8px;
}
.svg-icon-th,
.svg-icon-la,
.svg-icon-en {
  width: 1.5em;
  height: 1.5em;
  background-size: cover;
  float: left;
}
.svg-icon-th {
  background-image: url(~@/assets/logo/th-lang.svg);
}
.svg-icon-la {
  background-image: url(~@/assets/logo/la-lang.svg);
}
.svg-icon-en {
  background-image: url(~@/assets/logo/en-lang.svg);
}

.text-right {
  text-align: right !important;
}
</style>
